// extracted by mini-css-extract-plugin
export var subscribe = "Subscribe-module--subscribe--4cac7";
export var title = "Subscribe-module--title--aeb5b";